import { FormView } from '../account/form-view';
import firebase from "firebase/app";
import "firebase/auth";

export default FormView.extend({

    initialize: function(opts) {
        FormView.prototype.initialize.apply(this, [opts]);
        this.confirmationPassword = this.el.querySelector("#confirmationPassword");
        this.confirmationPassword.value = "";
    },

    executeOperation: function() {
        let emailAddress = this.el.querySelector("#emailAddress");
        return new Promise((resolve, reject) => {
            
            if (!emailAddress.value) reject(getI18N(jlocale.emailErrorempty));

            const authUser = firebase.auth().currentUser;
            const credentials = firebase.auth.EmailAuthProvider
                .credential(authUser.email, this.confirmationPassword.value);

            authUser.reauthenticateWithCredential(credentials)
                .then(() => authUser.updateEmail(emailAddress.value))
                .then(() => firebase.auth().currentUser.sendEmailVerification())
                .then(() => {
                    const { uid } = firebase.auth().currentUser;
                    return firebase.database()
                        .ref(`stylight/users/${uid}`)
                        .update({ email: emailAddress.value });
                })
                .then(() => {
                    this.confirmationPassword.value = "";
                    resolve();
                })
                .catch((error) => {
                    if (error.code === "auth/wrong-password") {
                        reject(getI18N(jlocale.wrongpassword));
                    } else if (error.code === "auth/email-already-in-use"){
                        reject(getI18N(jlocale.signupEmailAlreadyExists));
                    } else {
                        reject(getI18N(jlocale.error));
                    }
                });
            
        });
    }
})